"use strict";

(function (global) {


  /**  
  * Фабрика папок.
  * Предоставлет инструменты для работы с папками. Например, для создания новой папки, для поиска требуемой папки по ее ИД.
  *
  * @namespace WebAccess.factories.folders
  * @property {OBJECT_TYPE} WebAccess.factories.folders.contentType Тип содержимого фабрики
  * @since 5.0.0.7300
  */

  var FoldersFactory = global.factories.BaseFactory.extend({
    className: "FoldersFactory",

    contentType: OBJECT_TYPE.FOLDER,

    init: function () {
      this._super(this.contentType);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверить, являетя ли указаная папка корневой.
    *
    * @method WebAccess.factories.folders.isRootFolder
    * @param {Integer} folderID ИД папки
    * @return {Boolean} True – папка является корневой, иначе False.
    * @since 5.1.0.1523
    */
    isRootFolder: function(folderID) {
      return (!isNaN(folderID) && (folderID == InboxFolderID || folderID == OutboxFolderID || folderID == FavoritesFolderID || folderID == CommonFolderID));
    },

    /**
    * Получить ИД предопределенной папки.
    *
    * @method WebAccess.factories.folders.getRootFolderID
    * @param {FOLDER_TYPE} folderType Тип папки
    * @return {Deferred} ИД папки.
    * @since 5.0.0.7300
    *
    * @example <caption>Получить ИД предопределенной папки «Избранное» текущего пользователя</caption>
    * var favoritesId = WebAccess.factories.folders.getRootFolderID(FOLDER_TYPE.FAVORITES);
    */
    getRootFolderID: function (folderType) {
      switch (folderType) {
        case FOLDER_TYPE.INBOX:
          return InboxFolderID;
          break;
        case FOLDER_TYPE.OUTBOX:
          return OutboxFolderID;
          break;
        case FOLDER_TYPE.FAVORITES:
          return FavoritesFolderID;
          break;
        case FOLDER_TYPE.COMMON_FOLDER:
          return CommonFolderID;
          break;
        default:
          return null;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить папку по ее ИД.
    *
    * @method WebAccess.factories.folders.getFolderByID
    * @param {Integer} id ИД папки
    * @param {MODEL} opt_modelType Тип возвращаемой модели данных
    * @return {deferred} Искомая папка.
    * @since 5.0.0.7300
    *
    * @example <caption>Проверить, что папка существует.</caption>
    * WebAccess.factories.folders.getFolderByID().done(function(folder) {
	  *   console.log('Папка существует')
    * }).fail(function(error) {
    *  console.log('Не удалось найти папку с указанным id');
	  *  console.log(error);    
    * });
    */
    getFolderByID: function (id, opt_modelType) {
      return this.getObjectByID(id, opt_modelType);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Создать новую папку.
     *
     * @method WebAccess.factories.folders.createFolder
     * @param {FOLDER_CONTENT_TYPE} contentType Тип содержимого папки
     * @param {string} [opt_name] Наименование папки
     * @param {MODEL} opt_modelType Тип возвращаемой модели данных
     * @return {Deferred<Object>} Модель объекта.
     * @see https://api.jquery.com/category/deferred-object/
     * @throws ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED – заданы не все обязательные параметры.
     *
     * @example <caption>Создать папку и открыть ее карточку.</caption>
     * WA.FC.folders.сreateFolder(FOLDER_CONTENT_TYPE.ANY, 'FolderName').done(function(folder) {
     *   folder.open();
     * });
     *
     * @example <caption>Создать, настроить и сохранить папку. Сохраненная папка откроется в проводнике веб-доступа.</caption>
     * WA.FC.folders.сreateFolder({
     *  contentType: FOLDER_CONTENT_TYPE.ANY,
     *  name: 'Новая папка',
     *  autoSave: true
     * }).done(function(folder) {
     *  folder.open();
     * });
     */
    createFolder: function (contentType, opt_name, opt_modelType) {
      var me = this;
      var proxyCall = $.Deferred();
      opt_modelType = (!opt_modelType) ? MODEL.FULL : opt_modelType;

      var query = {};

      if ($.isPlainObject(contentType)) {
        query = contentType;

        if (contentType.hasOwnProperty('requisites')) {
          query.requisites = $.toJSON(contentType.requisites);
        };

        if (contentType.hasOwnProperty('bindTo')) {
          query.bindTo = contentType.bindTo.asString();
        }

      } else {
        if (contentType < 0) {
          WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED');
        }
        query.contentType = contentType;
        query.name = opt_name || null;
      };

      WA.SRV.call("/Factories.asmx/CreatePreConfiguredFolder", {
        Params: query,
        Mode: opt_modelType
      }).done(function (model) {
        proxyCall.resolve(me._handleModel(model, opt_modelType));
      }).fail(function (error) {
        proxyCall.reject(error);
      });;

      return proxyCall;
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.factories.folders = new FoldersFactory();
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess);